<template lang="html">

  <span
    class="change-indic"
    v-bind:class="[trendClass]">
    {{ visualization }}
  </span>

</template>

<script>
export default {
  name: "ChangeIndicator",
  props: ['value'],

  computed: {

    visualization () {
      if (this.value > 0) {
        return `+${this.value}`
      } else if (this.value < 0) {
        return this.value
      } else {
        return 0
      }
    },

    trendClass () {
      if (this.value > 0) {
        return 'negative'
      } else if (this.value < 0) {
        return 'positive'
      } else {
        return null
      }
    }

  }

}
</script>

<style lang="css" scoped>

.change-indic {
  color: #717171;
}

.change-indic.positive {
  color: #19981e;
}

.change-indic.negative {
  color: #c30000;
}

</style>
